import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMetricsGirdle = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "currentColor",
	viewBox: "0 0 48 48",
	...props,
	children: /* @__PURE__ */ _jsx("switch", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", { d: "m5.608 20.852 18.342 23.58 18.343-23.58zM3 15.669h42v2.392H3zM17.85 5.625 5.608 12.878h36.685L30.051 5.625z" }) }) })
});
export default SvgMetricsGirdle;
